import { isIOS } from '@/constants/environment'
import { useIpAddressField } from '@/features/settings/components/AddPrinterModal/form'
import LabeledInputField from '@/features/settings/components/forms/LabeledInputField'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'

const IpAddressField: FC = () => {
    const { t } = useTranslation()

    const [value, onChange] = useIpAddressField()

    const keyboardType = isIOS ? 'numbers-and-punctuation' : 'numeric'

    return (
        <LabeledInputField
            value={value || ''}
            onChange={onChange}
            label={t('settings.printers.addPrinterModal.field.ipAddress.label')}
            keyboardType={keyboardType}
        />
    )
}

export default IpAddressField
